<mat-form-field *ngIf="timeForm">
    <input matInput type="time" [formControl]="timeForm" [value]="timeForm.value">
  </mat-form-field>